import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { RouteComponentProps, navigate } from '@reach/router';
import InnerNav from 'components/InnerNav';
import { RootState } from 'store/store';
import { Box } from '../../../utils/style/extendable';
import styled from 'styled-components';
import { ICompany } from 'store/companies/companiesTypes';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  isAdvanceAdmin,
  isCompanyOwner,
  isCompanySupport,
} from 'store/companies/companiesUtils';

interface IStateToProps {
  company: ICompany;
  isCompanyOwner: boolean;
  isCompanyAdmin: boolean;
  isSupport: boolean;
  thisUser: IThisUserState;
  isAdvancedAdmin: boolean;
}

interface IOwnProps {
  companyId?: string;
  children: React.ReactNode;
}

const ConfigBox = styled(Box)`
  height: 100%;
  overflow: auto;
  display: flex;
`;
type IComponentProps = IOwnProps & IStateToProps & RouteComponentProps;

interface IState {
  showArchived: boolean;
}

class CompanyAdminContainer extends React.PureComponent<
  IComponentProps,
  IState
> {
  handleClickCreateButton = () => {
    const companyId = Number(this.props.companyId);
    navigate(`/t/${companyId}/project/create`);
  };
  state = {
    showArchived: false,
  };

  render() {
    const {
      isCompanyOwner,
      isCompanyAdmin,
      children,
      isSupport,
      isAdvancedAdmin,
    } = this.props;
    const companyId = Number(this.props.companyId);
    return (
      <React.Fragment>
        <>
          <div
            style={{
              margin: '10px',
              zIndex: 100,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isCompanyAdmin && (
              <InnerNav
                companyId={companyId}
                isOwnerOrSupport={isCompanyOwner || isSupport}
                isAdvancedAdmin={isAdvancedAdmin}
              />
            )}
          </div>
          {<ConfigBox style={{ paddingTop: '30px' }}>{children}</ConfigBox>}
        </>
      </React.Fragment>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const companyId = Number(props.companyId);

  const thisUser = state.thisUser;
  const company = state.companies.data[companyId];

  const isOwner = isCompanyOwner(thisUser, company);
  const isSupport = isCompanySupport(thisUser, company);
  const isCompanyAdmin = company.members[Number(thisUser.userId)].admin;
  const isAdvancedAdmin = isAdvanceAdmin(thisUser, company);
  return {
    thisUser,
    company,
    isCompanyOwner: isOwner,
    isCompanyAdmin,
    isSupport,
    isAdvancedAdmin,
  };
};

export default connect(mapStateToProps)(CompanyAdminContainer);
